import React from 'react'
import CustomToggle from '../../../components/CustomToggle';
import './invoiceTable.css'

const HalfRow = ({ id, title, subtitle, status, isHeader, onChange, canShowNa, isChangeable = false }) => {
  if (isHeader)
    return (
      <>
        <td style={{ padding: "14px 8px", width: "41%", backgroundColor: "darkslateblue", color: "white" }}>
          <strong style={{ fontSize: "14px" }}>{title}</strong>
        </td>
        <td style={{ width: "9%", textAlign: "center", backgroundColor: "darkslateblue", color: "white" }}>
          <strong style={{ fontSize: "14px" }}>{subtitle}</strong>
        </td>
      </>
    );
  return (
    <>
      <td style={{ padding: "4px 8px" }}>
        <div><strong style={{ fontSize: "14px" }} >{title}</strong></div>
        <small style={{ fontSize: "11px" }}>{subtitle}</small>
      </td>
      {!isChangeable && <td style={{ textAlign: "center" }}><small>{status}</small></td>}
      {isChangeable && <td style={{ textAlign: "center" }}><CustomToggle id={id} value={status} onChange={onChange} canShowNa={canShowNa} /></td>}
    </>
  );
}

const FullRow = ({ row1, row2, isChangeable }) => {
  return <>
    <HalfRow
      id={row1.id}
      title={row1.title}
      subtitle={row1.subtitle}
      status={row1.status}
      isHeader={row1.isHeader ?? false}
      onChange={row1.onChange}
      isChangeable={isChangeable}
      canShowNa={row1.canShowNa}
    />
    <HalfRow
      id={row2.id}
      title={row2.title}
      subtitle={row2.subtitle}
      status={row2.status}
      isHeader={row2.isHeader ?? false}
      onChange={row2.onChange}
      isChangeable={isChangeable}
      canShowNa={row2.canShowNa}
    />
  </>
}

const InvoiceTable = ({ section, isChangeable }) => {
  const rows = [];
  for (let i = 0; i < 15; i++) {
    rows.push(<tr key={i}><FullRow row1={section[i]} row2={section[i + 15]} isChangeable={isChangeable}></FullRow></tr>);
  }
  return (
    <table style={{ width: "100%" }}>
      <tbody>
        {rows}
      </tbody>
    </table>
  );
}

export default InvoiceTable